import classNames from "classnames/bind";
import styles from "./LiveVideo.module.css";
import Header from "./Header";
import StreamCamera from "./StreamCamera";
import React, { useContext, useEffect, useState } from "react";
import { LisencePlateContext } from "../../../../contexts";
import { LoadComponent, Pagination } from "../../../../components";
import { streamFSR } from "../../../../services/api/streamFSR";

const cx = classNames.bind(styles);

const LiveVideo = () => {
  const { screen, cameraCode, showInfo,
    setShowInfo,
    info,
    setInfo } = useContext(LisencePlateContext);
  const [streaming, setStreaming] = useState([]);
  const [isLoadingCamera, setIsLoadingCamera] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [listObject, setListObject] = useState([]);
  React.useEffect(() => {
    const getListPathStreaming = async () => {
      if (cameraCode && cameraCode.length > 0) {
        try {
          let listCameraCode = [];
          if (screen && screen.total === 1) {
            listCameraCode = [cameraCode[currentPage - 1]];
          } else {
            listCameraCode = cameraCode?.map((item) => {
              return { camera_code: item.camera_code };
            });
          }
          if (listCameraCode.length > 0) {
            const cameraCodes = listCameraCode?.map(item => {
              return item?.camera_code
            })
            // const res = await streamingClient.post(
            //   "/streamManagement/post-list-path-streaming/",
            //   {
            //     list_camera: {
            //       data: listCameraCode,
            //     },
            //   }
            // );
            // Lấy path video theo phần api của nhận diện khuôn mặt
            const bodyListCam = {
              cameraCodes: cameraCodes
            }
            const listPath = await streamFSR.postListCodeCam(bodyListCam)
            // // console.log(res);
            // // console.log(listPath);
            const listStream = listPath?.stream.map((item) => {
              if (item.code) {
                return {
                  url: `${process.env.REACT_APP_BASE_URL}livestream${item.data.length > 1
                    ? item?.data[1].PATH
                    : item?.data[0].PATH
                    }`,
                  url2: `${process.env.REACT_APP_BASE_URL}livestream${item?.data[0].PATH}`,
                  image: `${process.env.REACT_APP_BASE_URL}livestream/${item?.data[0]?.PATH?.split('/')[1]}/image.jpg`,
                  isOption: false,
                  name: item?.name,
                  status:
                    item?.status_active === 3
                      ? "Off"
                      : (item?.status_active === 2) |
                        (item?.status_active === 1)
                        ? "Weak"
                        : "On",
                  code: item.code,
                };
              }
              return null;
            });
            setStreaming(listStream);
            setIsLoadingCamera(false);
          } else {
            setStreaming([]);
            setIsLoadingCamera(false);
          }
        } catch (error) {
          setIsLoadingCamera(false);
          setStreaming([]);
          throw new Error("We can't get path streaming");
        }
      }
      else {
        setStreaming([])
      }
      setIsLoadingCamera(false);
    };
    const x = setInterval(() => {
      getListPathStreaming();
    }, 60000);
    getListPathStreaming();
    return () => {
      clearInterval(x);
    };
  }, [cameraCode, currentPage]);
  useEffect(() => {
    setCurrentPage(1)
  }, [cameraCode])
  const handleChosePage = (e) => {
    setInfo({})
    setShowInfo(false)
    setCurrentPage(e);
  }
  useEffect(() => {
    setListObject([])
    const eventSource = new EventSource(
      `${process.env.REACT_APP_FSR_IP}/server-events/stream-sse`

    );
    eventSource.onmessage = (event) => {
      // // console.log(event);
      if (JSON.parse(event.data).camera_code === streaming[0]?.code) {
        const objects = JSON.parse(event.data)
        // setListObject(objects);
        if (listObject.length <= 20) {
          setListObject(pre => [objects, ...pre])
        } else {
          const max = listObject.length;
          const data = listObject.filter((item, index) => index < max);
          setListObject([
            objects,
            ...data,
          ]);
        }
      }
    }
    eventSource.onerror = (error) => {
      eventSource.close();
    };
    return () => {
      eventSource.close();
    };
  }, [streaming[0]?.code]);
  // useEffect(() => {
  //   setListObject([])
  //   const eventSource = new EventSource(
  //     `${process.env.REACT_APP_FSR_IP}/server-events/warning-sse`
  //   );
  //   eventSource.onmessage = (event) => {
  //     if (JSON.parse(event.data).camera_code === streaming[0]?.code) {
  //       const objects = JSON.parse(event.data)
  //       // console.log(objects);
  //       // if (listObject.length <= 20) {
  //       //   setListObject(pre => [objects, ...pre])
  //       // } else {
  //       //   const max = listObject.length;
  //       //   const data = listObject.filter((item, index) => index < max);
  //       //   setListObject([
  //       //     objects,
  //       //     ...data,
  //       //   ]);
  //       // }
  //     }
  //   }
  //   eventSource.onerror = (error) => {
  //     eventSource.close();
  //   };
  //   return () => {
  //     eventSource.close();
  //   };
  // }, [streaming[0]?.code]);

  const handleNextPage = () => {
    setInfo({})
    setShowInfo(false)
    setCurrentPage(currentPage + 1);
  }
  const handlePrevPage = () => {
    setInfo({})
    setShowInfo(false)
    setCurrentPage(currentPage - 1);
  }
  return (
    <div className={cx("container")}>
      {isLoadingCamera ? (
        <div>
          <LoadComponent />
        </div>
      ) : (
        <>
          <Header />
          {streaming?.map((item) => {
            return <StreamCamera
              listObject={listObject}
              data={item}
              showPagination={cameraCode.length > 0 && screen.total === 1}
              currentPage={currentPage} totalPage={cameraCode?.length}
              handleChosePage={handleChosePage}
              handleNextPage={handleNextPage}
              handlePrevPage={handlePrevPage}
            />;
          })}
        </>
      )}
    </div>
  );
};

export default LiveVideo;
